import map from "lodash/map"
import join from "lodash/join"
import isEmpty from "lodash/isEmpty"
import flatten from "lodash/flatten"
import uniq from "lodash/uniq"
import commonApiAuthRequest from "../apiAuthRequest"
import { TOIR_SERVICE_URL, OSS_SERVICE_URL } from "./constants"

/*
  Спека
  https://next.stoplight.io/infotech-group/toir/version%2F1.0/inspection-service.oas2.yml?view=%2Freference%2Fcrew%2Ffindcrewmembers
*/

const crewFetch = visitId =>
  commonApiAuthRequest({
    url: `${TOIR_SERVICE_URL}/crew`,
    params: { query: `visitId=in=(${visitId})` },
  })

const addQuotes = string => `'${string}'`

const employeesFetch = codes =>
  commonApiAuthRequest({
    url: `${OSS_SERVICE_URL}/employees`,
    params: { query: `code=in=(${join(map(codes, addQuotes), `,`)})` },
  })

/**
 * makes requests to get crewMembers by visitId
 *
 * @param {number} visitId
 * @return {Array.<Object>} response - array of crewMembers
 */
export const getCrewMembers = async visitIds => {
  if (isEmpty(visitIds)) {
    return undefined
  }

  const crewResponse = await Promise.all(
    map(visitIds, payload => crewFetch(payload)),
  )
  const crews = flatten(map(crewResponse, `data`))

  if (isEmpty(crews)) {
    return []
  }

  const employeeCodes = uniq(map(crews, `employeeCode`))
  const { data: crewMembers } = await employeesFetch(employeeCodes)

  return crewMembers
}
